(function () {
  const handleCartItems = () => {
    let cartShadowDOM = document.getElementById("upCart");

    if(!cartShadowDOM) {
      return;
    };

    if(cartShadowDOM.shadowRoot) {
      cartShadowDOM = cartShadowDOM.shadowRoot;
    }
    
    const productsSection = cartShadowDOM.querySelector(".upcart-products-section");

    if(!productsSection) {
      return;
    };

    const items = cartShadowDOM.querySelectorAll(".upcart-product-item");

    if(items.length === 0) {
      return;
    };

    items.forEach((i) => {
      const target = i.querySelector(".upcart-item-property");

      if(!target) {
        return;
      };

      if(target.innerText === "Try before you buy") {
        const decrease = i.querySelector(".upcart-product-quantity-minus");
        const increment = i.querySelector(".upcart-product-quantity-plus");

        if(decrease || increment) {
          const child = decrease || increment;
      
          const parent = child.parentElement;
      
          if(parent) {
            parent.style.display = "none";
          }
        }
      }
    });
  }

  window.addEventListener("load", () => {
    handleCartItems();
    
    window.upcartOnCartUpdated = handleCartItems;
    window.upcartOnCartLoaded = handleCartItems;
    window.upcartRefreshCart = handleCartItems;
  });
})();